/* eslint-disable no-console */
/* eslint-disable curly */
/* eslint-disable no-unused-expressions */
import mfaInfoLogo from "@assets/images/mfa-info.svg";
import smLogo from "@assets/images/smo-blue.svg";
import {
  Box,
  Card,
  CircularProgress,
  CssBaseline,
  Divider,
  Paper,
  TextField,
  Typography
} from "@material-ui/core";
import CheckrOutlineIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { tokenVerifyMutation } from "@saleor/auth/mutations";
import {
  VerifyToken,
  VerifyTokenVariables
} from "@saleor/auth/types/VerifyToken";
import useNotifier from "@saleor/hooks/useNotifier";
import useUser from "@saleor/hooks/useUser";
import Cookies from "js-cookie";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useApolloClient, useMutation } from "react-apollo";
import { ThemeProvider } from "react-jss";
import { useNavigate } from "react-router";

import {
  useMfaEmailVerifyCode,
  useMfaSendCodeAttempt,
  useMfaSendEmailCode,
  useMfaVerifyCodeAttempt
} from "../../mutations";
import theme from "../../theme";
import MfaBackModalCard from "./MfaBackModalCard";
import MfaLockedOutPage from "./mfaLockedOutPage";
import useStyles from "./styles";

const MfaInputEmailCodePage: React.FC = () => {
  const classes = useStyles({});

  const [code, setCode] = useState<string[]>(new Array(6).fill(""));
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isValidating, setIsValidating] = useState(false);
  const inputRefs = useRef<Array<HTMLInputElement | null>>(
    new Array(6).fill(null)
  );
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const [sendCodeTimer, setSendCodeTimer] = useState(300);
  const [resendTimer, setResendTimer] = useState(300);
  const [, setRedirectCountdown] = useState<number | null>(null);
  const [redirectMessage, setRedirectMessage] = useState<string | null>(null);

  const [mfaEmailVerifyCode] = useMfaEmailVerifyCode({});
  const navigate = useNavigate();
  const [maxAttempts, setMaxAttempts] = useState<number | null>(null);
  const [setlockoutPeriod, setLockoutPeriod] = useState<number | null>(null);
  const [, setLockedAtDateTime] = useState<string | null>(null);
  const [attempts, setAttempts] = useState(0);

  const mfaState = JSON.parse(localStorage.getItem("mfaState")) as {
    userEmail?: string;
    createdAt?: string;
  } | null;

  const storedState = localStorage.getItem("mfaAuthLocalStorage");
  const parsedState = storedState ? JSON.parse(storedState) : {};

  const userEmail =
    mfaState?.userEmail ||
    parsedState?.userEmail ||
    Cookies.get("mfaUserEmail") ||
    "";

  const [resendSuccessful, setResendSuccessful] = useState<boolean>(false);

  const apolloClient = useApolloClient();
  const notify = useNotifier();
  const { loginByToken } = useUser();
  const [tokenVerify] = useMutation<VerifyToken, VerifyTokenVariables>(
    tokenVerifyMutation,
    {
      client: apolloClient,
      onCompleted: result => {
        if (result.tokenVerify === null) {
          notify({
            status: "error",
            text: ""
          });
        }
      }
    }
  );
  const handleVerifytoken = (token: string, csrfToken: string) => {
    tokenVerify({
      variables: {
        token
      }
    }).then(result => {
      if (
        result === undefined ||
        result?.data?.tokenVerify?.user === undefined
      ) {
        notify({
          status: "error",
          text: ""
        });
      } else {
        loginByToken(token, csrfToken, result.data.tokenVerify.user);
        navigate("/");
      }
    });
  };
  const {
    data: sendCodeData,
    refetch: refetchSendCode
  } = useMfaSendCodeAttempt({
    variables: { identifier: userEmail }
  });

  const {
    data: verifyCodeData,
    refetch: refetchVerifyCode
  } = useMfaVerifyCodeAttempt({
    variables: { identifier: userEmail }
  });

  useEffect(() => {
    refetchSendCode();
    refetchVerifyCode();
  }, []);
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [sendCodeTimeLeft, setSendCodeTimeLeft] = useState<number>(0);
  useEffect(() => {
    const sendCodeAttempt = sendCodeData?.mfaSendCodeAttempt;
    const verifyCodeAttempt = verifyCodeData?.mfaVerifyCodeAttempt;

    if (sendCodeAttempt) {
      const createdAt = sendCodeAttempt.createdAt;
      const resendCooldown = sendCodeAttempt.resendCooldown || 300;

      Cookies.set("mfaCreatedAt", createdAt, {
        expires: resendCooldown / 86400
      });
      Cookies.set("mfaResendCooldown", resendCooldown.toString(), {
        expires: resendCooldown / 86400
      });
      const resendCooldownCookie = Cookies.get("mfaResendCooldown");
      const createdAtCookie = Cookies.get("mfaCreatedAt");
      if (createdAtCookie && resendCooldownCookie) {
        const createdAtTime = new Date(createdAtCookie).getTime();
        const currentTime = new Date().getTime();
        const elapsedTime = Math.floor((currentTime - createdAtTime) / 1000);
        console.log(createdAtCookie, resendCooldownCookie);
        const cooldown = parseInt(resendCooldownCookie, 10) || 300;
        const remainingTime = Math.max(cooldown - elapsedTime, 0);
        console.log(createdAtCookie, resendCooldownCookie, elapsedTime);
        setSendCodeTimer(remainingTime);
        setSendCodeTimeLeft(remainingTime * 1000);
        setIsResendDisabled(remainingTime > 0);

        if (remainingTime > 0) {
          const interval = setInterval(() => {
            setSendCodeTimer(prev => {
              if (prev <= 1) {
                clearInterval(interval);
                setIsResendDisabled(false);
                setSendCodeTimeLeft(0);
                return 0;
              }
              setSendCodeTimeLeft(prevTime => Math.max(prevTime - 1000, 0));
              return prev - 1;
            });
          }, 1000);

          return () => clearInterval(interval);
        }
      } else {
        setIsResendDisabled(false);
        setSendCodeTimeLeft(0);
      }
      console.log(createdAtCookie, resendCooldownCookie);
      setLockoutPeriod(sendCodeAttempt.lockoutPeriod);
    }

    if (verifyCodeAttempt) {
      setAttempts(verifyCodeAttempt.mfaAttempts);
      setLockoutPeriod(verifyCodeAttempt.lockoutPeriod);
      setMaxAttempts(verifyCodeAttempt.maxAttempts);
    }
  }, [sendCodeData, verifyCodeData]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const remainingSeconds = (seconds % 60).toString().padStart(2, "0");
    return `${minutes}:${remainingSeconds}`;
  };

  const handleChange = (index: number, value: string) => {
    if (!/^[0-9]?$/.test(value) || isValidating) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
    if (newCode.join("").length === 6) {
      setIsValidating(true);
      setTimeout(() => validateCode(newCode.join("")), 500);
    }
  };
  const [, setIsLoading] = useState(false);
  const [, setErrorLockedOut] = useState(null);

  const validateCode = async (enteredCode: string) => {
    setIsValidating(true);

    try {
      const responseEmailVerify = await mfaEmailVerifyCode({
        variables: { code: enteredCode, email: userEmail }
      });
      const resultEmail = responseEmailVerify.data?.mfaVerifyCode;
      const result = resultEmail;
      const mfaSetupDate = Cookies.get("mfaSetupDate");

      if (result.data?.maxAttempts) setMaxAttempts(result.data.maxAttempts);
      if (result.data?.mfaAttempts) setAttempts(result.data.mfaAttempts);
      if (result.data?.lockoutPeriod)
        setLockoutPeriod(result.data.lockoutPeriod);

      if (!resultEmail.success && resultEmail.message === "MFA806") {
        notify({
          status: "error",
          text:
            "Your verification code has expired. Please resend a new code to proceed."
        });
        return;
      }

      if (
        result.data?.mfaAttempts >= result.data?.maxAttempts &&
        mfaSetupDate !== "null"
      ) {
        Cookies.set("EmailLockedOut", "true");
        Cookies.remove("PhoneLockedOut");
        const lockoutDuration = result.data?.lockoutPeriod || 300;
        const lockoutExpiresInSeconds =
          Math.floor(Date.now() / 1000) + lockoutDuration;

        Cookies.set("lockoutUntil");

        console.log("Lockout expires at:", lockoutExpiresInSeconds);
        setLockoutPeriod(lockoutDuration);
        setLockedAtDateTime(result.data.lockedAt);
        console.log("Locked at:", result.data.lockedAt);
        setErrorLockedOut(
          `You are locked out for ${lockoutDuration / 60} minutes.`
        );
        return;
      }

      if (
        result.data?.mfaAttempts >= result.data?.maxAttempts &&
        mfaSetupDate === "null"
      ) {
        const setLockout = lockoutSeconds => {
          const now = Math.floor(Date.now() / 1000);
          const lockoutUntil = now + lockoutSeconds;
          Cookies.set("lockoutUntil", lockoutUntil.toString(), {
            expires: 1
          });
        };

        setLockout(result.data.lockoutPeriod);
        Cookies.set("hasMaxAttemptsEmail", "true");
        Cookies.set("hasMaxAttemptsPhone", "false");
        Cookies.set("isEmailResendCooldown", "false");
        Cookies.set("isPhoneResendCooldown", "false");
        Cookies.remove("isPhoneClicked");
        navigate("/mfa-auth-page/", {
          state: { userEmail: userEmail! }
        });

        notify({
          status: "error",
          text:
            "Maximum verification attempts reached. Try again later or use another method"
        });
      }

      if (result?.success && result?.token) {
        setSuccess("Authentication successful!");
        setAttempts(0);
        setError(null);
        Cookies.remove("EmailLockedOut");

        let countdown = 3;
        setRedirectCountdown(countdown);
        setRedirectMessage(`${countdown}s`);

        const interval = setInterval(() => {
          countdown -= 1;
          setRedirectCountdown(countdown);

          if (countdown === 0) {
            clearInterval(interval);
            setIsLoading(true);
            setRedirectMessage(null);
            handleVerifytoken(result.token, result.csrfToken);
          } else {
            setRedirectMessage(`${countdown}s`);
          }
        }, 1000);
      } else {
        setError("Incorrect Authentication Code!");
        setTimeout(() => {
          setError(null);
          setCode(new Array(6).fill(""));
          inputRefs.current[0]?.focus();
        }, 2000);
      }
    } catch (err) {
      console.error("Verification error:", err);
      setError("Incorrect Authentication Code!");
    } finally {
      setIsValidating(false);
    }
  };

  const [sendEmailCode] = useMfaSendEmailCode({});
  const [isResending, setIsResending] = useState(false);

  const handleResendCode = async () => {
    if (isResendDisabled) return;
    setIsResendDisabled(true);
    setIsResending(true);
    try {
      const responseEmailVerify = await sendEmailCode({
        variables: { email: userEmail }
      });

      if (responseEmailVerify.data?.mfaSendCode?.success) {
        setCode(Array(code.length).fill(""));
        inputRefs.current.forEach(input => {
          if (input) input.value = "";
        });
        const createdAt = responseEmailVerify.data.mfaSendCode.data.createdAt;
        const resendCooldown =
          responseEmailVerify.data.mfaSendCode.data.resendCooldown || 300;

        Cookies.set("mfaCodeSent", "true", {
          expires: resendCooldown / 86400
        });
        Cookies.set("mfaCreatedAt", createdAt, {
          expires: resendCooldown / 86400
        });
        Cookies.set("mfaUserEmail", userEmail, {
          expires: resendCooldown / 86400
        });
        Cookies.set("mfaResendCooldown", resendCooldown.toString(), {
          expires: resendCooldown / 86400
        });

        setResendTimer(resendCooldown);
        setTimeLeft(resendCooldown * 1000);
        setResendSuccessful(true);

        const interval = setInterval(() => {
          setResendTimer(prev => {
            if (prev === 1) {
              clearInterval(interval);
              setIsResendDisabled(false);
              setTimeLeft(0);
              return 0;
            }
            setTimeLeft(prevTime => prevTime - 1000);
            return prev - 1;
          });
        }, 1000);
      } else {
        notify({ status: "error", text: "MFA Email Code Sending Failed" });
      }
    } catch (err) {
      console.error("Error sending email code:", err);
    } finally {
      setIsResending(false);
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    const target = e.target as HTMLInputElement;
    if (e.key === "Backspace" && !target.value && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const minutesSendCode = Math.floor(Math.max(sendCodeTimeLeft, 0) / 60000)
    .toString()
    .padStart(2, "0");
  const secondsSendCode = Math.floor(
    (Math.max(sendCodeTimeLeft, 0) % 60000) / 1000
  )
    .toString()
    .padStart(2, "0");

  const handlePaste = (e, startIndex) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    const numbers = pastedData
      .replace(/\D/g, "")
      .split("")
      .slice(0, code.length - startIndex);

    numbers.forEach((num, i) => {
      handleChange(startIndex + i, num);
    });

    const nextIndex = startIndex + numbers.length;
    if (nextIndex < inputRefs.current.length) {
      inputRefs.current[nextIndex].focus();
    }
  };

  const [showBackModal, setShowBackModal] = useState(false);

  const handlePopState = useCallback((event: PopStateEvent) => {
    event.preventDefault();
    setShowBackModal(true);

    window.history.pushState(null, "", window.location.href);
  }, []);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [handlePopState]);

  const handleStay = () => {
    setShowBackModal(false);
  };
  const mfaSetupDate = Cookies.get("mfaSetupDate");
  const handleLeave = () => {
    window.removeEventListener("popstate", handlePopState);
    if (mfaSetupDate !== "null") {
      navigate("/");
    } else {
      window.history.go(-2);
    }
  };

  return (
    <>
      <MfaBackModalCard
        open={showBackModal}
        onLeave={handleLeave}
        onConfirm={handleStay}
        onClose={handleStay}
        onGotIt={handleStay}
        isMfaProcessed={isValidating}
      />

      <ThemeProvider theme={theme}>
        <CssBaseline />

        <Box className={classes.centerContainer}>
          <img className={classes.logo} src={smLogo} alt="SM Logo" />
          {Cookies.get("EmailLockedOut") ? (
            <>
              <MfaLockedOutPage
                lockoutDuration={setlockoutPeriod}
                userEmail={userEmail}
              ></MfaLockedOutPage>
            </>
          ) : (
            <>
              <Card className={classes.card}>
                <Typography
                  variant="h5"
                  component="h5"
                  className={classes.title}
                >
                  Enter Authentication Code
                </Typography>
                {!isValidating && !error && !success && (
                  <Typography className={classes.subtitle}>
                    Please type the <b>6-digit code</b> sent to your userEmail,{" "}
                    <b>{userEmail}</b>,{" "}
                    {!resendSuccessful &&
                      sendCodeTimer !== 0 &&
                      isResendDisabled && (
                        <>
                          within{" "}
                          <b>
                            {minutesSendCode}:{secondsSendCode}s.
                          </b>
                        </>
                      )}
                  </Typography>
                )}
                <Box
                  display="flex"
                  justifyContent="center"
                  style={{ gap: "10px" }}
                >
                  {code.map((digit, index) => (
                    <TextField
                      autoComplete="off"
                      key={index}
                      variant="outlined"
                      inputRef={el => {
                        if (el) inputRefs.current[index] = el;
                      }}
                      value={digit}
                      disabled={isValidating}
                      onChange={e => handleChange(index, e.target.value)}
                      onKeyDown={e => handleKeyDown(index, e)}
                      onPaste={e => handlePaste(e, index)}
                      inputProps={{
                        className: classes.input,
                        maxLength: 1
                      }}
                      InputProps={{
                        className: `${classes.outlinedInput} ${
                          isValidating || error
                            ? classes.errorBackground
                            : success
                            ? classes.successBackground
                            : classes.defaultBackground
                        }`
                      }}
                      className={`${classes.textField} ${
                        isValidating || error || success
                          ? classes.pointerDisabled
                          : classes.pointerEnabled
                      }`}
                    />
                  ))}
                </Box>
                {isValidating && !error && !success && (
                  <Box className={classes.validationContainer}>
                    <Typography
                      variant="body2"
                      className={classes.textValidatingCode}
                    >
                      Validating Code
                    </Typography>
                    <CircularProgress
                      size={18}
                      className={classes.circularProgress}
                    />
                  </Box>
                )}

                {!isValidating && success && (
                  <Box className={classes.container}>
                    <CheckrOutlineIcon className={classes.icon} />
                    <Typography className={classes.text}>{success}</Typography>
                  </Box>
                )}
                {!isValidating && error && (
                  <Box className={classes.containerError}>
                    <ErrorOutlineIcon className={classes.iconError} />
                    <Typography className={classes.textError}>
                      {error}
                    </Typography>
                  </Box>
                )}
                {attempts > 0 &&
                  !isValidating &&
                  !error &&
                  !success &&
                  maxAttempts !== null && (
                    <Typography className={classes.textAttemptError}>
                      Remaining attempts: ({attempts}/{maxAttempts})
                    </Typography>
                  )}

                {!isValidating && !error && !success && (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography className={classes.subtitle12} align="center">
                      Please <b>check your SPAM or junk folder</b> if it's not
                      in your inbox.
                    </Typography>
                    <Divider style={{ width: "100%" }} />

                    <Box display="flex" alignItems="center">
                      <Typography
                        className={classes.textResendCode}
                        onClick={
                          !isResendDisabled || !isResending
                            ? handleResendCode
                            : undefined
                        }
                        style={{
                          color: isResendDisabled ? "#999" : "#247CFF",
                          cursor: isResendDisabled ? "default" : "pointer",
                          fontWeight: 500
                        }}
                      >
                        {`Resend Authentication Code ${
                          isResendDisabled && timeLeft !== 0
                            ? `(${formatTime(resendTimer)})`
                            : ""
                        }`}
                      </Typography>

                      {isResending && (
                        <CircularProgress
                          size={20}
                          style={{
                            color: isResending ? "#999" : "#247CFF"
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                )}
              </Card>

              {!isValidating && !error && !success && (
                <Box>
                  <Paper
                    className={classes.infoCard}
                    elevation={0}
                    style={{ flex: 1, padding: "0px 0px" }}
                  >
                    <Box
                      style={{
                        backgroundColor: "#002972",
                        borderBottomLeftRadius: 8,
                        borderTopLeftRadius: 8,
                        height: 50,
                        width: 8
                      }}
                    ></Box>
                    <img
                      className={classes.infoLogo}
                      src={mfaInfoLogo}
                      alt="MFA info"
                      style={{ padding: "2px 2px" }}
                    />
                    <Typography
                      style={{ fontSize: 12, padding: "0px 10px" }}
                      align="left"
                    >
                      <b>Need help?</b> Reach out to{" "}
                      <b>smmallsonline.acquisition@smsupermalls.com</b>
                    </Typography>
                  </Paper>
                </Box>
              )}
              {redirectMessage && (
                <Typography style={{ color: "#494E56", fontSize: "14px" }}>
                  Redirecting to <b>Dashboard after {redirectMessage}</b>.
                </Typography>
              )}
            </>
          )}
        </Box>
      </ThemeProvider>
    </>
  );
};

export default MfaInputEmailCodePage;
